import { render, staticRenderFns } from "./Triangle4.vue?vue&type=template&id=289971e8&"
import script from "./Triangle4.vue?vue&type=script&lang=js&"
export * from "./Triangle4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports